<template>
  <ChipBadge v-if="label" color="default" size="s" rounded>
    {{ label }}
  </ChipBadge>
</template>

<script setup lang="ts">
import { ChipBadge } from '@ramp106/omrjs-core-ui'
import { computed } from 'vue'

import { fieldValue } from './blockHelpers'
import type { NotificationBlock } from './types'

const props = defineProps<{
  block: NotificationBlock
}>()

const label = computed(() => fieldValue(props.block, 'label'))
</script>
